import * as ambassadorWixEcomV1AbandonedCheckout from './ecom-v1-abandoned-checkout-abandoned-checkouts.http.js';
import * as ambassadorWixEcomV1AbandonedCheckoutTypes from './ecom-v1-abandoned-checkout-abandoned-checkouts.types.js';
import * as ambassadorWixEcomV1AbandonedCheckoutUniversalTypes from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAbandonedCheckout(): __PublicMethodMetaInfo<
  'GET',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutResponse &
    ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.GetAbandonedCheckoutResponseNonNullableFields,
  ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutResponse &
    ambassadorWixEcomV1AbandonedCheckoutTypes.GetAbandonedCheckoutResponseNonNullableFields
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.getAbandonedCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/abandoned-checkout/{abandonedCheckoutId}',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAbandonedCheckout(): __PublicMethodMetaInfo<
  'DELETE',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.DeleteAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.DeleteAbandonedCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.DeleteAbandonedCheckoutResponse,
  ambassadorWixEcomV1AbandonedCheckoutTypes.DeleteAbandonedCheckoutResponse
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.deleteAbandonedCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/abandoned-checkout/{abandonedCheckoutId}',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAbandonedCheckouts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.QueryAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.QueryAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.QueryAbandonedCheckoutsResponse &
    ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.QueryAbandonedCheckoutsResponseNonNullableFields,
  ambassadorWixEcomV1AbandonedCheckoutTypes.QueryAbandonedCheckoutsResponse &
    ambassadorWixEcomV1AbandonedCheckoutTypes.QueryAbandonedCheckoutsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.queryAbandonedCheckouts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkout/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchAbandonedCheckouts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.SearchAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.SearchAbandonedCheckoutsRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.SearchAbandonedCheckoutsResponse &
    ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.SearchAbandonedCheckoutsResponseNonNullableFields,
  ambassadorWixEcomV1AbandonedCheckoutTypes.SearchAbandonedCheckoutsResponse &
    ambassadorWixEcomV1AbandonedCheckoutTypes.SearchAbandonedCheckoutsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.searchAbandonedCheckouts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkout/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addAbandonedCheckoutActivity(): __PublicMethodMetaInfo<
  'POST',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.AddAbandonedCheckoutActivityRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.AddAbandonedCheckoutActivityRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.AddAbandonedCheckoutActivityResponse &
    ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.AddAbandonedCheckoutActivityResponseNonNullableFields,
  ambassadorWixEcomV1AbandonedCheckoutTypes.AddAbandonedCheckoutActivityResponse &
    ambassadorWixEcomV1AbandonedCheckoutTypes.AddAbandonedCheckoutActivityResponseNonNullableFields
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.addAbandonedCheckoutActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandoned-checkouts/{abandonedCheckoutId}/add-activity',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function redirectToCheckout(): __PublicMethodMetaInfo<
  'GET',
  { abandonedCheckoutId: string },
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.RedirectToCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutTypes.RedirectToCheckoutRequest,
  ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.RawHttpResponse &
    ambassadorWixEcomV1AbandonedCheckoutUniversalTypes.RawHttpResponseNonNullableFields,
  ambassadorWixEcomV1AbandonedCheckoutTypes.RawHttpResponse &
    ambassadorWixEcomV1AbandonedCheckoutTypes.RawHttpResponseNonNullableFields
> {
  const payload = { abandonedCheckoutId: ':abandonedCheckoutId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1AbandonedCheckout.redirectToCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/abandoned-checkout/{abandonedCheckoutId}/redirect-to-checkout',
    pathParams: { abandonedCheckoutId: 'abandonedCheckoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
